module.exports = __webpack_public_path__ + "img/404.5014ce3c.png";